import { Line } from "vue-chartjs";

export default {
  extends: Line,
  props: {
    chartdata: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: { display: false },
      title: {
        display: true,
        text: "Ouverture vs. fermeture"
      }
    }
  }),
  mounted() {
    this.renderChart(this.chartdata, this.options);
  }
};
